export default __webpack_public_path__ + "static/media/_DSC0259.9f313418.JPG";